import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Mail, Phone, Linkedin, Send } from "lucide-react";
import { PROFILE } from "../../data/content";
import { track } from "../../lib/track";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { name: "", email: "", subject: "", message: "" };

export const Contact = () => {
  const [form, setForm] = useState(EMPTY);

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.subject || !form.message) {
      toast.error("Please complete all fields.");
      return;
    }
    track("contact_submit", form.subject);
    // Keep a best-effort copy on the server (non-blocking).
    axios.post(`${API}/contact`, form).catch(() => {});
    // Route the enquiry straight to Augustus's inbox via the visitor's email client.
    const body = `Name: ${form.name}\nEmail: ${form.email}\n\n${form.message}`;
    const mailto = `mailto:${PROFILE.email}?subject=${encodeURIComponent(form.subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailto;
    toast.success(`Opening your email app to send to ${PROFILE.email}.`);
    setForm(EMPTY);
  };

  return (
    <section className="cta-section dark-zone" id="contact" aria-labelledby="cta-heading">
      <div className="cta-inner">
        <div className="section-label" style={{ textAlign: "center", marginBottom: "var(--space-4)" }}>
          Commission an Engagement
        </div>
        <h2 className="cta-heading" id="cta-heading">Ready to Turn Evidence into <em>Action?</em></h2>
        <p className="cta-sub">
          Whether you need a rigorous evaluation, a MEL system that drives learning, or a grant proposal
          that wins — let's discuss your evidence challenge.
        </p>

        <form className="contact-form" onSubmit={submit} data-testid="contact-form">
          <div className="form-grid">
            <div className="form-field">
              <label className="form-label" htmlFor="cf-name">Name</label>
              <input id="cf-name" className="form-input" type="text" placeholder="Your full name"
                     value={form.name} onChange={update("name")} data-testid="contact-name" />
            </div>
            <div className="form-field">
              <label className="form-label" htmlFor="cf-email">Email</label>
              <input id="cf-email" className="form-input" type="email" placeholder="you@organisation.org"
                     value={form.email} onChange={update("email")} data-testid="contact-email" />
            </div>
          </div>
          <div className="form-field full">
            <label className="form-label" htmlFor="cf-subject">Subject</label>
            <input id="cf-subject" className="form-input" type="text" placeholder="e.g. Mid-term evaluation enquiry"
                   value={form.subject} onChange={update("subject")} data-testid="contact-subject" />
          </div>
          <div className="form-field full">
            <label className="form-label" htmlFor="cf-message">Message</label>
            <textarea id="cf-message" className="form-textarea" placeholder="Tell me about your programme, timeline, and evidence needs…"
                      value={form.message} onChange={update("message")} data-testid="contact-message" />
          </div>
          <button type="submit" className="btn-primary form-submit" data-testid="contact-submit">
            <Send size={16} /> Send Message
          </button>
          <p className="form-note">This opens your email app addressed to {PROFILE.email}. Prefer to email directly? Reach me at {PROFILE.email}</p>
        </form>

        <div className="contact-details">
          <a href={`mailto:${PROFILE.email}`} className="contact-item" data-testid="contact-email-link">
            <Mail size={14} /> {PROFILE.email}
          </a>
          <a href={`tel:${PROFILE.phoneGH.replace(/\s/g, "")}`} className="contact-item">
            <Phone size={14} /> {PROFILE.phoneGH} (GH)
          </a>
          <a href={`tel:${PROFILE.phoneNG.replace(/\s/g, "")}`} className="contact-item">
            <Phone size={14} /> {PROFILE.phoneNG} (NG)
          </a>
          <a href={PROFILE.linkedin} target="_blank" rel="noopener noreferrer" className="contact-item">
            <Linkedin size={14} /> LinkedIn
          </a>
        </div>
      </div>
    </section>
  );
};
